import { useSelector } from 'react-redux';

import { TextOld } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { getWindowWidth } from '~/store/reducers/app/selectors';
import { COLORS } from '~/styles/colors';

import arrowBottom from '../assets/arrow-bottom.png';
import arrowTop from '../assets/arrow-top.png';

import { StyledBottomArrow, StyledCard, StyledImage, StyledNumber, StyledText, StyledTopArrow } from './styled';

const Card = ({ id, img, text }) => {
  const width = useSelector(getWindowWidth);
  const renderTopArrow = (width > 1295 && [1, 3, 5].includes(id)) || (width <= 1295 && [1, 4].includes(id));
  const renderBottomArrow = (width > 1295 && [2, 4].includes(id)) || (width <= 1295 && [2, 5].includes(id));

  return (
    <StyledCard>
      {renderTopArrow && <StyledTopArrow src={arrowTop} alt="arrow" />}
      {renderBottomArrow && <StyledBottomArrow src={arrowBottom} alt="arrow" />}
      <StyledImage src={img} alt={id} />
      <StyledNumber>
        <Title type={TITLE_TYPE.h3} color={COLORS.white}>
          {id}
        </Title>
      </StyledNumber>
      <StyledText>
        <TextOld color={COLORS.grey400} fontWeight={400} textAlign="center" fontSize={16}>
          {text}
        </TextOld>
      </StyledText>
    </StyledCard>
  );
};

export default Card;
